import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ASSESTS, SVG } from '../../constants/constants';
import { SvgGeneratorService } from '../../services/svg-generator.service';


@Component({
    selector: 'app-img-generator',
    templateUrl: './img-generator.component.html',
    styleUrls: ['./img-generator.component.scss']
})
export class ImgGeneratorComponent implements OnInit {
    @Input() public imgUrl = '';

    public src!: string;

    @ViewChild('loadSvgImage', { static: false }) public loadSvgImage!: ElementRef<HTMLInputElement>;

    constructor(private svgGeneratorService: SvgGeneratorService) {}

    public ngOnInit(): void {
        const imgUrl = ASSESTS + this.imgUrl;

        if (imgUrl.indexOf(SVG) !== -1) {
            this.svgGeneratorService.loadSvg(imgUrl).subscribe (svg => {
                this.loadSvgImage.nativeElement.outerHTML = svg;
            });
        } else {
            this.src = imgUrl;
        }
    }
}
